import { Typography, Stack } from '@mui/material';
import React, { useCallback, useState } from 'react';
import DropdownAutocomplete from '../DropdownAutocomplete';
import GenDataText from '../GenDataText';
import { EditableFieldWrapper } from './EditableFieldWrapper';

export const PaymentServiceDropdown = ({
  text,
  enablePaymentEditableFields,
  apiIsLoading,
  services = [],
  editServiceFunction = () => {},
  vendorOrderId = '',
}) => {
  const [edit, setEdit] = useState(false);
  const serviceId = text[2];
  const [selectedService, setSelectedService] = useState(null);

  const handleEditButtonClick = useCallback(() => {
    setEdit(prev => !prev);
  }, []);

  const handleBlur = () => setEdit(prev => !prev);

  const handleChange = item => {
    if (!item) return;
    setSelectedService(item);
    editServiceFunction({
      vendorOrderId,
      serviceId,
      value: item?.servicePriceId,
      field: 'name',
    });
  };

  if (!enablePaymentEditableFields) {
    return (
      <GenDataText
        textVariant="body2"
        textColor="textPrimary"
        text={`${text[1]}x ${text[0]}`}
      />
    );
  }

  return (
    <EditableFieldWrapper
      edit={edit}
      onEditClick={handleEditButtonClick}
      isLoading={apiIsLoading?.loading && apiIsLoading?.service === serviceId}
      serviceId={serviceId}
    >
      {edit ? (
        <Stack direction="row" gap={1} alignItems="center">
          <GenDataText
            textVariant="body2"
            textColor="textPrimary"
            text={`${text[1]}x`}
          />
          <DropdownAutocomplete
            sx={{ width: '300px' }}
            renderAvatar={false}
            dropdownData={services}
            handleOnChange={handleChange}
            renderOption={(props, option) => (
              <Typography>{option.label}</Typography>
            )}
            label="label"
            id="servicePriceId"
            multiSelect={false}
            value={selectedService}
            handleBlur={handleBlur}
            placeholder="Service"
          />
        </Stack>
      ) : (
        <GenDataText
          textVariant="body2"
          textColor="textPrimary"
          text={`${text[1]}x ${text[0]}`}
        />
      )}
    </EditableFieldWrapper>
  );
};
